/**
 * Social media links per speaker. Only include platforms the speaker has.
 * Used by SpeakerSocialLinks component on homepage and speaker pages.
 */
export const SPEAKER_SOCIAL_LINKS = {
  'matthew-walker': [
    { type: 'youtube', href: 'https://www.youtube.com/channel/UCA3FB1fOtY4Vd8yqLaUvolg', label: 'YouTube' },
    { type: 'instagram', href: 'https://www.instagram.com/drmattwalker/', label: 'Instagram' },
    { type: 'linkedin', href: 'https://www.linkedin.com/in/sleepdiplomat/', label: 'LinkedIn' },
    { type: 'x', href: 'https://x.com/sleepdiplomat', label: 'X' },
    { type: 'website', href: 'https://www.sleepdiplomat.com/', label: 'Website' },
  ],
  'david-sinclair': [
    { type: 'youtube', href: 'https://www.youtube.com/channel/UCwD5YYkbYmN2iFHON9FyDXg/', label: 'YouTube' },
    { type: 'instagram', href: 'https://www.instagram.com/davidsinclairphd/?hl=en', label: 'Instagram' },
    { type: 'linkedin', href: 'https://www.linkedin.com/in/davidsinclairphd', label: 'LinkedIn' },
    { type: 'facebook', href: 'https://www.facebook.com/davidsinclairphd/', label: 'Facebook' },
    { type: 'x', href: 'https://x.com/davidasinclair', label: 'X' },
    { type: 'website', href: 'https://davidasinclair.com/', label: 'Website' },
  ],
  'daniel-amen': [
    { type: 'youtube', href: 'https://www.youtube.com/c/DrDanielAmen_BrainHealth', label: 'YouTube' },
    { type: 'instagram', href: 'https://www.instagram.com/doc_amen/', label: 'Instagram' },
    { type: 'linkedin', href: 'https://www.linkedin.com/in/drdanielamen', label: 'LinkedIn' },
    { type: 'facebook', href: 'https://www.facebook.com/drdanielamen/', label: 'Facebook' },
    { type: 'x', href: 'https://x.com/DocAmen', label: 'X' },
    { type: 'website', href: 'https://www.amenclinics.com/', label: 'Website' },
  ],
  'diana-palotas': [
    { type: 'youtube', href: 'https://www.youtube.com/watch?v=6XnvEf4VFyg', label: 'YouTube' },
    { type: 'instagram', href: 'https://www.instagram.com/dianaspraxis/', label: 'Instagram' },
    { type: 'linkedin', href: 'https://ro.linkedin.com/in/dianapalotas1', label: 'LinkedIn' },
    { type: 'facebook', href: 'https://www.facebook.com/profile.php?id=100090240313191', label: 'Facebook' },
    { type: 'website', href: 'https://neuros.ro/', label: 'Website' },
  ],
  'niculina-gheorghita': [
    { type: 'youtube', href: 'https://www.youtube.com/@Holisterapia', label: 'YouTube' },
    { type: 'instagram', href: 'https://www.instagram.com/gheorghita.niculina/', label: 'Instagram' },
    { type: 'linkedin', href: 'https://ro.linkedin.com/in/niculina-g-4961a63b', label: 'LinkedIn' },
    { type: 'facebook', href: 'https://www.facebook.com/Holisterapia/', label: 'Facebook' },
    { type: 'tiktok', href: 'https://www.tiktok.com/discover/niculina-gheorghita?lang=en', label: 'TikTok' },
    { type: 'website', href: 'https://niculinagheorghita.ro/', label: 'Website' },
  ],
};
